<template>
  <div class="website-top" :class="{ dark: theme === 'dark' }">
    <div class="top-container">
      <div class="top-item">
        <div @click="openHome" class="top-home">首页</div>
        <div class="top-city"><i></i>北京</div>
        <div class="top-slogan">欢迎来到兜赞福利</div>
        <!-- <div class="top-link">请登录</div> -->
        <!-- <div class="top-link">免费注册</div> -->
      </div>
      <div class="top-item">
        <div class="head-login">登录账号</div>
        <div class="top-divider"></div>
        <div class="head-reg">免费注册</div>
        <div class="top-divider"></div>
        <div class="top-link">我的卡券</div>
        <div class="top-divider"></div>
        <div class="top-link">我的订单</div>
        <div class="top-divider"></div>
        <div class="top-link">购物车</div>
        <div class="top-divider"></div>
        <div class="top-link">收藏夹</div>
        <div class="top-divider"></div>
        <div class="top-link">个人中心</div>
      </div>
    </div>

    <el-dialog
      :show-close="false"
      :visible.sync="loginDialog.visible"
      width="360px"
      append-to-body
    >
      <div
        class="login-dialog"
        :style="{
          height: loginDialog.formHeight,
        }"
      >
        <swiper
          ref="loginTab"
          :slides-per-view="3"
          :space-between="50"
          @swiper="loginTabChange"
          @slideChange="loginTabChange"
        >
          <swiper-slide>
            <div class="login-home">
              <el-image
                class="login-home-logo"
                src="https://res.hjfile.cn/co/pass/1.3.21/49a85fdde6adfd56d65b474ded34794d.svg"
              ></el-image>

              <div class="login-wx">微信登录</div>
              <div @click="setLoginTab(1)" class="login-mobile">手机号登录</div>
              <div @click="setLoginTab(1)" class="login-pwd">账号密码登录</div>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="login-account">
              <el-button @click="setLoginTab(0)" type="primary"
                >setLoginTab(1)</el-button
              >
            </div>
          </swiper-slide>
        </swiper>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.min.css";
export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      loginDialog: {
        visible: false,
        formHeight: "450px",
        formIndex: 0,
        form: {},
      },
    };
  },
  props: {
    theme: {
      type: String,
      default: "light",
    },
  },
  created() {},
  methods: {
    onSwiper() {},
    onSlideChange() {},
    setLoginTab(index) {
      this.$refs.loginTab.$swiper.slideTo(index, 200, false);
    },
    loginTabChange() {
      let index = this.$refs.loginTab.$swiper.realIndex;
      console.log("loginTabChange", index);
      if (index === 0) this.loginDialog.formHeight = "450px";
      else if (index === 1) this.loginDialog.formHeight = "480px";
    },
    openHome() {
      this.$router.push({
        path: "/",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.website-top {
  position: sticky;
  top: 0;
  left: 0;
  width: 100%;
  height: 40px;
  background-color: #f7f8fa;
  z-index: 1000;

  display: flex;
  align-items: center;
  justify-content: center;

  .top-container {
    width: 1200px;
    height: 30px;

    display: flex;
    align-items: center;
    justify-content: space-between;

    .top-item {
      display: inline-flex;
      align-items: center;

      .top-home {
        margin-right: 6px;
        font-size: 12px;
        color: #666666;
        cursor: pointer;

        &:hover {
          color: #f10215;
        }
      }

      .top-city {
        margin-right: 6px;
        font-size: 12px;
        color: #666666;
        cursor: pointer;

        display: inline-flex;
        align-items: center;

        i {
          display: inline-block;
          width: 18px;
          height: 18px;
          // margin-right: 2px;
          background-size: 36px 18px;
          background-image: url(https://image.ydleague.com/benefit/web_icons/icon_normal_position.png);
        }

        &:hover {
          color: #f10215;

          i {
            background-position: -18px 0;
          }
        }
      }

      .top-slogan {
        margin: 0 6px;
        font-size: 12px;
        color: #666666;
      }

      .head-login {
        margin: 0 6px;
        font-size: 12px;
        color: #666666;
        cursor: pointer;

        &:hover {
          color: #f10215;
        }
      }

      .head-reg {
        margin: 0 6px;
        font-size: 12px;
        color: #f10215;
        cursor: pointer;
      }

      .top-link {
        margin: 0 6px;
        font-size: 12px;
        color: #666666;
        cursor: pointer;

        &:hover {
          color: #f10215;
        }

        &:last-child {
          margin-right: 0;
        }
      }

      .top-divider {
        width: 1px;
        height: 10px;
        margin: 0 6px;
        background-color: #dfe2e6;
      }
    }
  }

  &.dark {
    background-color: #141414;

    .top-container {
      .top-item {
        .top-slogan {
          color: rgba($color: #ffffff, $alpha: 0.6);
        }

        .top-home,
        .top-city,
        .head-login,
        .top-link {
          color: rgba($color: #ffffff, $alpha: 0.6);

          &:hover {
            color: #ffffff;
          }
        }

        .top-divider {
          background-color: rgba($color: #ffffff, $alpha: 0.1);
        }
      }
    }
  }
}

.login-dialog {
  background-color: #ffffff;
  border-radius: 10px;
  transition: all 0.2s;

  .login-home {
    width: 100%;
    height: 100%;
    padding: 85px 28px 0;
    box-sizing: border-box;
    background-size: 100% auto;
    background-repeat: no-repeat;
    background-image: url(data:image/svg+xml;base64,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);
    // background-image: url(https://image.ydleague.com/benefit/bg/icon_web_loginbg2.jpg);

    display: flex;
    flex-direction: column;
    align-items: center;

    .login-home-logo {
      width: 168px;
      height: 89px;
    }
    .login-wx {
      width: 100%;
      height: 40px;
      margin-top: 75px;
      border-radius: 20px;
      background-color: #1472ff;

      line-height: 40px;
      text-align: center;
      font-size: 15px;
      color: #ffffff;
      cursor: pointer;
    }

    .login-mobile {
      width: 100%;
      height: 40px;
      margin-top: 24px;
      border-radius: 20px;
      background-color: rgba($color: #1472ff, $alpha: 0.2);

      line-height: 40px;
      text-align: center;
      font-size: 15px;
      color: #1472ff;
      cursor: pointer;
    }

    .login-pwd {
      width: 100%;
      height: 40px;
      margin-top: 24px;

      line-height: 40px;
      text-align: center;
      font-size: 14px;
      color: #8a9099;
      cursor: pointer;
    }
  }
}
</style>
